<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-form v-model="valid" ref="form">
        <v-card-text>
        <v-layout column>
          <v-flex>
          <v-textarea
            ref="focused"
            label="Текст"
            rows="5"
            hint=""
            v-model="item.text"
            :rules="[v=>!!v || 'введите текст']"
          ></v-textarea>
        </v-flex>
        <v-flex>
          <v-layout row>
            <v-text-field
              prepend-icon="attach_file"
              @click:prepend="dialogOpen"
              label="Ссылка на документ"
              hint=""
              v-model="item.link"
            ></v-text-field>
            <v-btn :disabled='!this.item.link' @click="addLink">Добавить</v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
      </v-card-text>
    </v-form>
    <template #actions>
      <v-btn :disabled='!valid' @click="add">Направить</v-btn>
      <v-spacer></v-spacer>
    </template>  
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import depo from '../depo'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'post-form',
    components: {vBtnForm},
    data: () => ({
      docSelector: false,
      edit: false,
      valid: false,
      item: {}
    }),
    props: {
      itemId: {
        type: Number,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.item = this.getItemNew()
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        chat: 'getChatterChat',
        profile: 'getProfile',
        getDepoUrl: 'getDepoUrl'
      }),
      title () {
        return 'Направить сообщение'
      },
      docLink () {
        return this.item.link ? this.item.link : ''
      }
    },
    methods: {
      add () {
        if (this.$refs.form.validate()) {
          this.item.chatId = this.chat.id
          this.$store.dispatch('addChatterPost', this.item)
          this.edit = false
          this.cancel()
        }
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          id: null,
          chatId: null,
          text: '',
          typeCode: 'PLAIN',
          expiryTime: null,
          link: null
        }
      },
      addLink () {
        this.item.text = this.item.text + `<a href="${this.docLink}">${this.docLink}</a>`
        this.item.link = null
      },
      setDoc: function (value) {
        var docLink = this.getDepoUrl(value)
        this.item.link = docLink
      },
      dialogOpen: function () {
        depo.selectDoc(this, this.setDoc)
      }
    }

  }

</script>




// WEBPACK FOOTER //
// PostForm.vue?7a2983d2